import * as resultOfConsiderPreviousType from './resultOfConsiderPreviousType'
import useResultOfConsiderPrevious from './useResultOfConsiderPrevious'

import Grid from '@material-ui/core/Grid'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import useTranslate from '../../../../../../i18n/useTranslate'
import Dialog from '../../../../../../control/dialog/dialog'
// import useCheckPermission from '../../../../../../utilities/checkPermission'
import MyAccordion from '../../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../../control/richTextEditor/richTextEditor'
import { approveStatusREC1, approveStatusREC2 } from '../../../../../../constants/approveStatus'

//View
const ResultOfConsiderPreviousView = (props: resultOfConsiderPreviousType.ResultOfConsiderPreviousViewType) => {
    const { formRef, isViewMode, initialValues, /*projectData,*/ configDialog, onRefDialog, initialSuggestionNotice } =
        props

    const translate = useTranslate()
    // const checkPermission = useCheckPermission()

    const isApproveWithComment =
        initialValues?.approveStatus?.value === approveStatusREC1.approveWithComment.toString() ||
        initialValues?.approveStatus?.value === approveStatusREC2.approveWithComment.toString()

    const isApprove =
        initialValues?.approveStatus?.value === approveStatusREC1.approve.toString() ||
        initialValues?.approveStatus?.value === approveStatusREC2.approve.toString()

    return (
        <Form
            onSubmit={() => {}}
            initialValues={{ ...initialValues }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(formProps) => {
                formRef.current = formProps
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                    <Grid item xs={12} md={12} lg={12}>
                                        {translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :{' '}
                                        {/* {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? initialValues?.approveStatus?.label
                                            : initialValues?.approveStatus?.label} */}
                                        {isApproveWithComment
                                            ? translate.get('LABEL.APPROVE')
                                            : initialValues?.approveStatus?.label}
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            {!isApprove && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.SUGGESTION_NOTICE')}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <RichTextEditor
                                                name={`suggestionNotice`}
                                                initialRichTextEditor={initialSuggestionNotice}
                                                disabled={isViewMode}
                                                isHideToolbar={isViewMode}
                                            />
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}
                        </Grid>
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}

//Controller
const ResultOfConsiderPrevious = (props: resultOfConsiderPreviousType.ResultOfConsiderPreviousType) => {
    const useMemomessageTerminateModel = useResultOfConsiderPrevious(props)
    return <ResultOfConsiderPreviousView {...useMemomessageTerminateModel} {...props} />
}
export default ResultOfConsiderPrevious
